import { Fragment } from "react";

export const NoteMessageContainer = ({
  heading = "Note",
  contant,
  className = "",
}) => {
  return (
    <Fragment>
      {contant && (
        <div className="col-lg-12">
          <div className={"courier-pickup-msg submit-order-note " + className}>
            <h4>{heading}</h4>
            {contant.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};
